import { AsYouType, type CountryCode } from 'libphonenumber-js';

/**
 * Formats a phone number as it is typed. It lives apart from `formatting.ts`, and outside the
 * `@shared/utils` barrel, so that only phone code loads `libphonenumber-js` (CUR-2481).
 */
export function formatPhoneNumber(phoneNumber: string | null | undefined, defaultCountryCode?: CountryCode) {
    if (!phoneNumber) {
        return '';
    }

    const asYouType = new AsYouType(defaultCountryCode);
    return asYouType.input(phoneNumber);
}
